/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./calendar.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./calendar.component";
import * as i3 from "../../shared/components/breadcrumbs/breadcrumbs.service";
var styles_CalendarComponent = [i0.styles];
var RenderType_CalendarComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_CalendarComponent, data: {} });
export { RenderType_CalendarComponent as RenderType_CalendarComponent };
export function View_CalendarComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "h1", [["class", "page-title"]], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["Napt\u00E1r"])), (_l()(), i1.ɵted(-1, null, ["\n\n"])), (_l()(), i1.ɵeld(3, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["Elk\u00E9sz\u00EDt\u00E9s alatt..."])), (_l()(), i1.ɵted(-1, null, ["\n"]))], null, null); }
export function View_CalendarComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "kkk-calendar", [], null, null, null, View_CalendarComponent_0, RenderType_CalendarComponent)), i1.ɵdid(1, 114688, null, 0, i2.CalendarComponent, [i3.BreadcrumbsService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var CalendarComponentNgFactory = i1.ɵccf("kkk-calendar", i2.CalendarComponent, View_CalendarComponent_Host_0, {}, {}, []);
export { CalendarComponentNgFactory as CalendarComponentNgFactory };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/contents/calendar/calendar.component.ngfactory.js.pre-build-optimizer.js